import React from 'react';
import cc from 'classcat';
import {
  FontAwesomeIcon,
  FontAwesomeIconProps
} from '@fortawesome/react-fontawesome';

interface IconProps extends Omit<FontAwesomeIconProps, 'title'> {
  title?: boolean | string;
}

const Icon: React.FC<IconProps> = ({ className, title, ...props }) => {
  const classes = cc(['text-small', className ? className : null]);
  return (
    <FontAwesomeIcon
      className={classes}
      title={typeof title === 'string' ? title : null}
      {...props}
    />
  );
};

export default Icon;
